import axios from 'axios'

export default axios

const config = require('./config.js');

/**@global CONSTANTES DE CONFIGURACION */



/** 
 * @constant 
 * @description Constantes de URL de la API
 */
export const URLAPI = config.ENV_URL_API;


export const EMPLEOS_ENDPOINT = '/empleos/'
export const ESTADOS_ENDPOINT = '/base/estados/'
export const EMPLEOS_NOAUTH_ENDPOINT = '/empleos/empleos/'
export const LOGIN_ENDPOINT = '/base/login/'
export const LOGOUT_ENDPOINT = '/base/logout/'
export const ENVIAR_POSTULACION_ENDPOINT = '/empleos/enviar-postulacion/'
export const POSTULANTES_ENDPOINT = '/empleos/postulantes/'
export const USUARIOS_ENDPOINT = '/base/usuarios/'
export const USUARIO_UPDATE_ENDPOINT = '/base/usuario/update/'
export const PASSWORD_RESET = '/base/password/reset/'
export const PASSWORD_CONFIRM = '/base/rest-auth/password/reset/confirm/'
export const CONTACT_ENDPOINT = '/base/contacto/'
export const CORREO_CONTACTO_ENDPOINT = '/base/correo/'

export const GROUP_LIST = '/base/group/list'
export const GROUP_UPDATE = '/base/group/update/'
export const GROUP_CREATE = '/base/group/create'
export const PERMMISSION_LIST = '/base/permission/list'